import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useImperativeHandle, useRef } from 'react';
import { styled } from 'styled-components';
import { Box } from "../../../box/src";
import { Loader } from "../../../loader/src";
import { useProperty } from '../hooks/useProperty';
export const Content = forwardRef((_a, inputRef) => {
    var { children, isLoading, isSmall, parentId, pb, property = 'modal-body', pt, viewportRef } = _a, props = __rest(_a, ["children", "isLoading", "isSmall", "parentId", "pb", "property", "pt", "viewportRef"]);
    const ref = useRef(null);
    useProperty(isLoading ? { current: null } : ref, 'dialog', parentId, property);
    useImperativeHandle(inputRef, () => ref.current, [ref]);
    return (_jsx(ContentStyled, Object.assign({ "$isLoading": isLoading, ref: viewportRef }, props, { children: isLoading ? (_jsx(LoaderStyled, { children: _jsx(Loader, { size: 72 }) })) : (_jsx(Box, { display: "block", height: isSmall ? '100%' : 'auto', pb: pb, pt: pt, ref: ref, width: "100%", children: children })) })));
});
const LoaderStyled = styled(Box).attrs({
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '100%',
    pb: 6,
}) ``;
const ContentStyled = styled(Box).attrs(({ $isLoading }) => (Object.assign(Object.assign({}, (!$isLoading && { display: 'block' })), { overflowY: 'auto' }))) `
  grid-area: modal-body;
  transition: min-height 0.2s;
`;
//# sourceMappingURL=Content.js.map